import type { ReactNode } from "react";
import { AuthProvider } from "./AuthProvider";
import { PreferencesProvider } from "./PreferencesProvider";
import { I18nProvider } from "../i18n/I18nProvider";
import { ToastProvider } from "../components/Toast";

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <I18nProvider>
      <PreferencesProvider>
        <ToastProvider>
          <AuthProvider>{children}</AuthProvider>
        </ToastProvider>
      </PreferencesProvider>
    </I18nProvider>
  );
}
